
export default function colorLoop(exclude = '', callback) {
    let types = ['hsl', 'hsv', 'rgb', 'hex'];
    for(let i in types) {
        let type = types[i];
        if(type !== exclude) {
            callback(type);
        }
    }
}